import PhoneNumberForm from './PhoneNumberForm';

export default PhoneNumberForm;
